import React, { useState } from 'react';

import { TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import clsx from 'clsx';
import { useDebouncedCallback } from 'use-debounce';

import styles from './styles';

export const HelperText = ({ error, helperText }) =>
  error && helperText ? (
    <>
      <ErrorOutlineIcon />
      <span>{helperText}</span>
    </>
  ) : helperText ? (
    helperText
  ) : null;

export function NumberInput(props) {
  const {
    classes: classesProp,
    className,
    value: initialValue = '',
    delay = 2,
    error = undefined,
    helperText = undefined,
    onChange = null,
    onBlur = null,
    ...other
  } = props;
  const [value, setValue] = useState(initialValue);

  const { textInputRoot, clearIndicator, clearIndicatorDirty, formHelperMessage: contained, ...classes } = classesProp;

  const handleOnChangeDebounce = useDebouncedCallback(value => {
    const numberValue = Number(value);
    setValue(numberValue);
    if (typeof onChange === 'function') {
      onChange({ target: { value: numberValue } });
    }
  }, delay);

  function handleChange(event) {
    handleOnChangeDebounce(event.target.value);
  }

  return (
    <TextField
      className={clsx(className, textInputRoot)}
      delay={delay}
      InputProps={{
        classes,
      }}
      defaultValue={value}
      type='number'
      onChange={handleChange}
      onBlur={onBlur}
      variant='outlined'
      FormHelperTextProps={{ classes: { contained } }}
      helperText={helperText && <HelperText error={error} helperText={helperText} />}
      {...other}
    />
  );
}

export default withStyles(styles)(NumberInput);
